import React from 'react'; // eslint-disable-line

import { Divider, Grid, Paper, Typography, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { OpenModal, openModalAction } from '../../../../../form-modal/actions';
import { getLifeAssuredDetails, Payment } from '../../../../../life-assured-details/reducer';
import { State } from '../../../../../redux/root-reducer';
import { formatCurrency, getDisplayDate } from '../../../../../shared-functions';
import { Nullable } from '../../../../../shared-types';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { NonRaDeathWrapper } from '../../../../../forms';

type Props = StyledComponent & {
    previousPayments?: Nullable<Payment[]>;
    openModal: OpenModal;
    isReadOnly: boolean;
    isUnderWriting?: boolean;
};

const previousPaymentsView: React.FunctionComponent<Props> = ({
    classes,
    previousPayments,
    openModal,
    isUnderWriting,
    isReadOnly,
}: Props) => {
    if (!previousPayments || previousPayments.length === 0) {
        return (
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={3} alignItems="center">
                    <Typography variant="subtitle2">Previous Payments</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Typography>
                            No payments have been made, Please check the decision section for any
                            notes related to this claim
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
        );
    }

    return (
        <NonRaDeathWrapper>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={3} alignItems="center">
                    <Typography variant="subtitle2">Previous Payments</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        {previousPayments.length === 0 && (
                            <Typography>
                                No previous payments selected for current life assured1
                            </Typography>
                        )}
                        {previousPayments.map((previousPayment, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {index !== 0 && (
                                        <Divider
                                            className={classNames(
                                                classes.marginTop,
                                                classes.marginBottom
                                            )}
                                        />
                                    )}
                                    <Grid container spacing={1}>
                                        <Grid item xs={2}>
                                            <LabeledValue
                                                label="Policy Number"
                                                value={previousPayment.policyNumber}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <LabeledValue
                                                label="Benefit Name"
                                                value={previousPayment.benefitDescription}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <LabeledValue
                                                label="Payment Date"
                                                value={getPaymentDate(previousPayment)}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <LabeledValue
                                                label="Sum Assured"
                                                value={formatCurrency(previousPayment.sumAssured)}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <LabeledValue
                                                label="Amount Payable"
                                                value={formatCurrency(previousPayment.amount)}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <LabeledValue
                                                label="Percentage Payable"
                                                value={previousPayment.percentage + '%'}
                                            />
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Typography style={{ color: '#4ad0f5e4' }}>
                                                View payment details on Decision Notes
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </React.Fragment>
                            );
                        })}
                    </Paper>
                </Grid>
            </Grid>
        </NonRaDeathWrapper>
    );
};

function getPaymentDate(previousPayment: Payment): string {
    const paymentDate = getDisplayDate(previousPayment.firstPaymentDate);
    if (!previousPayment.lastPaymentDate) {
        return paymentDate;
    }

    return `${paymentDate} - ${getDisplayDate(previousPayment.lastPaymentDate)}`;
}

const mapStateToProps = (state: State) => ({
    previousPayments: getLifeAssuredDetails(state).previousPayments,
    isReadOnly: state.claimSession.readOnly,
});

const mapDispatchToProps = {
    openModal: openModalAction,
};

export const PreviousPaymentsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(previousPaymentsView));
